import { handlerGetUrlParams } from '@/utils/dealUrlParams'
import request from '@/utils/request'

// 查询信息
export function getMGeneralInfo(param) {
  const url = handlerGetUrlParams('/bus/information/desclist', param)
  return request({
    url,
    method: 'GET'
  })
}

// 搜索
export function searchMGeneralInfo(param) {
  const url = handlerGetUrlParams('/bus/information/publishlist', param)
  return request({
    url,
    method: 'GET'
  })
}

// 查看详细信息
export function checkMGeneralInfo(id) {
  return request({
    url: `/bus/information/${id}`,
    method: 'GET'
  })
}

// 查询热门文章
export function getHotInfo(param) {
  const url = handlerGetUrlParams('/bus/information/hotlist', param)
  return request({
    url,
    method: 'GET'
  })
}

// 添加浏览器量
export function updateViews(id) {
  return request({
    url: `/bus/information/is_view/${id}`,
    method: 'PUT'
  })
}